<ion-header>
  <ion-toolbar>
    <ion-title>Add Additional Information</ion-title>
    <ion-buttons slot="end">
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card-content>

    <form>
      <div slot="label">
        First Name <ion-text color="danger">*</ion-text>
        <ion-item class="custom-input">
          <ion-input type="text" [value]="firstName" inputmode="first_name" (ionInput)="onFirstNameInput($event)"
            (keydown)="preventLeadingSpace($event, firstName)">
          </ion-input>
        </ion-item>
      </div>
      <div slot="label">
        Last Name <ion-text color="danger">*</ion-text>
        <ion-item class="custom-input">
          <ion-input type="text" [value]="lastName" inputmode="last_name" (ionInput)="onLastNameInput($event)"
            (keydown)="preventLeadingSpace($event, lastName)">
          </ion-input>
        </ion-item>
      </div>
      <ion-button class="ion-margin" (click)="submit()" expand="block" [disabled]="!firstName || !lastName">
        Save
      </ion-button>
    </form>


  </ion-card-content>
</ion-content>